<paper-input id="search-bar" name="search-bar" label="{{'Search cases'|translate}}" #searchBar></paper-input>
<div id="search-results" #searchResults>
</div>
  